import { DialogContent } from "@mui/material";
import { LocalShippingOutlined } from "@mui/icons-material";
import {
	MoleDialog,
	MoleDialogHeader,
	useMoleThemeColor,
} from "../../components/MoleDialogShell";
import SupplySituation from "../supply/SupplySituation";

interface Props {
	title: string;
	isOpen: boolean;
	toggle: () => void;
	bundle: any;
	onPayment?: () => void;
}

const Supplies = ({ title, isOpen, toggle, bundle, onPayment }: Props) => {
	const themeColor = useMoleThemeColor();

	return (
		<MoleDialog
			open={isOpen}
			onClose={toggle}
			maxWidth="xl"
			fullWidth
			themeColor={themeColor}
			paperOptions={{ maxWidth: "95%", width: "95%", maxHeight: "95vh" }}
		>
			<MoleDialogHeader
				title={title}
				subtitle={bundle?.name || bundle?.supplier}
				icon={<LocalShippingOutlined />}
				onClose={toggle}
				themeColor={themeColor}
			/>
			<DialogContent sx={{ pt: 1 }}>
				<SupplySituation bundle={bundle} onCallback={onPayment} />
			</DialogContent>
		</MoleDialog>
	);
};

export default Supplies;